/**
 * AiToolsList Component
 *
 * Side paper listing the read-only data an automation's AI can load by itself. It sits in the
 * flow of its row and is always shown whole — the prompt beside it stretches to match.
 */
import { cn, Icon, Paper } from '@insio/ui-toolkit';

export interface AiToolsListProps {
  title: string;
  description: string;
  /** One line per tool the AI may call. */
  items: string[];
  /** Sits beside a labelled field and lines up with its box; false when it stands alone. */
  isBesideField?: boolean;
  className?: string;
  testId?: string;
}

export function AiToolsList({
  title,
  description,
  items,
  isBesideField = true,
  className,
  testId
}: AiToolsListProps) {
  return (
    <div className={cn('flex flex-col gap-xs', className)}>
      {/* Stands in for the InputWrapper label, so both boxes start at the same height. */}
      {isBesideField && <span aria-hidden='true' className='hidden lg:flex h-7' />}
      <Paper testId={testId} showDivider={false} className='flex-1 border border-border-base'>
        <Paper.Title className='py-0 text-base font-semibold text-foreground-base text-center'>
          {title}
        </Paper.Title>
        <Paper.Content>
          <p className='text-sm text-foreground-muted mt-xs'>{description}</p>
          <ul className='mt-sm space-y-xs'>
            {items.map(item => (
              <li key={item} className='flex items-start gap-sm text-sm'>
                <Icon
                  name='check'
                  className='w-4 h-4 mt-2xs text-success-text shrink-0'
                  aria-hidden='true'
                />
                <span className='text-foreground-base leading-snug'>{item}</span>
              </li>
            ))}
          </ul>
        </Paper.Content>
      </Paper>
    </div>
  );
}
